export function resetRefinementUI() {
  const dropdownEls = document.querySelectorAll('[data-facet-state]');

  dropdownEls.forEach((node) => {
    node.setAttribute('data-facet-state', 'UNPINNED');

    node.querySelectorAll('input[type="checkbox"]').forEach((option) => {
      if (option instanceof HTMLInputElement) {
        // eslint-disable-next-line no-param-reassign
        option.checked = false;
      }
    });

    node.querySelectorAll('input[type="radio"]').forEach((option) => {
      if (option instanceof HTMLInputElement) {
        // eslint-disable-next-line no-param-reassign
        option.checked = Boolean(
          option.value === '' && option.type === 'radio',
        );
      }
    });
  });

  document
    .querySelectorAll('#overflow-dropdown input[type="checkbox"]')
    .forEach((option) => {
      if (option instanceof HTMLInputElement) {
        // eslint-disable-next-line no-param-reassign
        option.checked = false;
      }
    });

  document
    .querySelectorAll('#overflow-dropdown input[type="radio"]')
    .forEach((option) => {
      if (option instanceof HTMLInputElement) {
        // eslint-disable-next-line no-param-reassign
        option.checked = Boolean(
          option.value === '' && option.type === 'radio',
        );
      }
    });

  // TODO: SearchFacetCheckboxOptions and SearchFacetRadioButtonOptions
  // render their inputs with `defaultChecked` (uncontrolled), so React doesn't
  // sync the DOM when state clears externally — e.g. Clear Filters in the new
  // mobile filter modal. This pass is the workaround. Migrate those two
  // components to controlled inputs (`checked={...}`) and remove this block.
  document.querySelectorAll('[data-facet-type]').forEach((node) => {
    node.querySelectorAll('input[type="checkbox"]').forEach((option) => {
      if (option instanceof HTMLInputElement) {
        // eslint-disable-next-line no-param-reassign
        option.checked = false;
      }
    });

    node.querySelectorAll('input[type="radio"]').forEach((option) => {
      if (option instanceof HTMLInputElement) {
        // eslint-disable-next-line no-param-reassign
        option.checked = Boolean(
          option.value === '' && option.type === 'radio',
        );
      }
    });
  });
}
